export const STATE_COLORS = {
  EARLY_TRANSITION: '#0ea5e9',
  BULLISH_CONFIRMATION: '#10b981',
  UPTREND: '#2563eb',
  BASE_BUILDING: '#f59e0b',
  FAILED_TRANSITION: '#ef4444',
  DOWNTREND: '#64748b',
};

export const STATE_OPTIONS = [
  'EARLY_TRANSITION',
  'BULLISH_CONFIRMATION',
  'UPTREND',
  'BASE_BUILDING',
  'FAILED_TRANSITION',
  'DOWNTREND',
];

export const CONFIDENCE_OPTIONS = ['HIGH', 'MEDIUM', 'LOW'];

export const SIGNAL_TYPE_OPTIONS = [
  'EARLY_TRANSITION',
  'CONFIRMED_BREAKOUT',
  'TREND_CONTINUATION',
  'FAILED_TRANSITION',
  'WATCH',
];

export const filterScanRows = (rows, {
  search = '',
  stateFilter = 'ALL',
  confidence = 'ALL',
  signalType = 'ALL',
} = {}) => (
  (rows || []).filter((row) => {
    if (search && !row.ticker?.toLowerCase().includes(search.toLowerCase())) return false;
    if (stateFilter !== 'ALL' && row.state !== stateFilter) return false;
    if (confidence !== 'ALL' && row.confidence !== confidence) return false;
    if (signalType !== 'ALL' && row.signal_type !== signalType) return false;
    return true;
  })
);

export const fmtNumber = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return Number(value).toFixed(digits);
};

export const fmtPrice = (value, digits = 0) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtPct = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return `${(Number(value) * 100).toFixed(digits)}%`;
};

export const stateColor = (state) => STATE_COLORS[state] || '#64748b';

export const getLocalizedText = (value, language, fallback = '—') => {
  if (!value) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value !== 'object') return fallback;

  const normalizedLanguage = String(language || 'en').toLowerCase();
  const preferredKey = normalizedLanguage.startsWith('vi') ? 'vi' : 'en';
  return value[preferredKey] || value.en || value.vi || fallback;
};

export const getStateLabel = (t, state) => {
  if (!state) return '—';
  return t(`ichimokuTransition.states.${state}`);
};

export const getConfidenceLabel = (t, confidence) => {
  if (!confidence) return '—';
  return t(`ichimokuTransition.confidenceLevels.${confidence}`);
};

export const getSignalTypeLabel = (t, signalType) => {
  if (!signalType) return '—';
  return t(`ichimokuTransition.signalTypes.${signalType}`);
};